import { Timeseries } from "@hydrologiq/schemas/1.0.0/installationPage"
export enum TimePeriod {
    LastThirtyMinutes = "Last 30 minutes",
    LastOneHour = "Last 1 hour",
    LastThreeHours = "Last 3 hours",
    LastSixHours = "Last 6 hours",
    LastTweleveHours = "Last 12 hours",
    LastTwentyFourHours = "Last 24 hours",
    LastThreeDays = "Last 3 days",
    LastWeek = "Last week",
    LastMonth = "Last month",
    LastThreeMonths = "Last 3 months",
    LastSixMonths = "Last 6 months",
    LastTweleveMonths = "Last 12 months",
    ALL = "Entire period"
}
import {
  LAST_30_MINUTES_SCALE,
  LAST_1_HOUR_SCALE,
  LAST_3_HOURS_SCALE,
  LAST_6_HOURS_SCALE,
  LAST_MONTH_SCALE,
  LAST_MONTHS_MORE_3_SCALE,
  LAST_MONTHS_SCALE,
  LAST_WEEK_SCALE,
} from "./timeScales"

type TimePeriodMap = { [key in TimePeriod]?: Timeseries }

export const TimePeriodMappings: TimePeriodMap = {
  [TimePeriod.LastThirtyMinutes]: {
    endResolution: { quantity: 5, resolution: "minute" },
    startResolution: { quantity: 32, resolution: "minute" },
    interval: { quantity: 1, resolution: "second" },
    scale: LAST_30_MINUTES_SCALE,
  },
  [TimePeriod.LastOneHour]: {
    endResolution: { quantity: 5, resolution: "minute" },
    startResolution: { quantity: 1, resolution: "hour" },
    interval: { quantity: 1, resolution: "minute" },
    scale: LAST_1_HOUR_SCALE,
  },
  [TimePeriod.LastThreeHours]: {
    endResolution: { quantity: 15, resolution: "minute" },
    startResolution: { quantity: 3, resolution: "hour" },
    interval: { quantity: 1, resolution: "minute" },
    scale: LAST_3_HOURS_SCALE,
  },
  [TimePeriod.LastSixHours]: {
    endResolution: { quantity: 15, resolution: "minute" },
    startResolution: { quantity: 6, resolution: "hour" },
    interval: { quantity: 1, resolution: "minute" },
    scale: LAST_6_HOURS_SCALE,
  },
  [TimePeriod.LastTweleveHours]: {
    endResolution: { quantity: 2, resolution: "hour" },
    startResolution: { quantity: 12, resolution: "hour" },
    interval: { quantity: 30, resolution: "minute" },
    scale: {
      normal: { quantity: 1, resolution: "hour" },
      mobile: { quantity: 2, resolution: "hour" },
    },
  },
  [TimePeriod.LastTwentyFourHours]: {
    endResolution: { quantity: 60, resolution: "minute" },
    startResolution: { quantity: 24, resolution: "hour" },
    interval: { quantity: 10, resolution: "minute" },
    scale: {
      normal: { quantity: 2, resolution: "hour" },
      mobile: { quantity: 3, resolution: "hour" },
    },
  },
  [TimePeriod.LastThreeDays]: {
    endResolution: { quantity: 1, resolution: "hour" },
    startResolution: { quantity: 3, resolution: "day" },
    interval: { quantity: 1, resolution: "hour" },
    scale: {
      normal: { quantity: 6, resolution: "hour" },
      mobile: { quantity: 12, resolution: "hour" },
    },
  },
  [TimePeriod.LastWeek]: {
    endResolution: { quantity: 4, resolution: "hour" },
    startResolution: { quantity: 7, resolution: "day" },
    interval: { quantity: 1, resolution: "hour" },
    scale: LAST_WEEK_SCALE,
  },
  [TimePeriod.LastMonth]: {
    endResolution: { quantity: 8, resolution: "hour" },
    startResolution: { quantity: 30, resolution: "day" },
    interval: { quantity: 12, resolution: "hour" },
    scale: LAST_MONTH_SCALE,
  },
  [TimePeriod.LastThreeMonths]: {
    endResolution: { quantity: 24, resolution: "hour" },
    startResolution: { quantity: 90, resolution: "day" },
    interval: { quantity: 24, resolution: "hour" },
    scale: LAST_MONTHS_SCALE,
  },
  [TimePeriod.LastSixMonths]: {
    endResolution: { quantity: 2, resolution: "day" },
    startResolution: { quantity: 180, resolution: "day" },
    interval: { quantity: 7, resolution: "day" },
    scale: LAST_MONTHS_MORE_3_SCALE,
  },
  [TimePeriod.LastTweleveMonths]: {
    endResolution: { quantity: 2, resolution: "day" },
    startResolution: { quantity: 365, resolution: "day" },
    interval: { quantity: 7, resolution: "day" },
    scale: LAST_MONTHS_MORE_3_SCALE,
  },
  [TimePeriod.ALL]: undefined,
}
